import ImageEditableMeta from './ImageEditableMeta';

export default ImageEditableMeta;
